<mat-toolbar class="mat-primary">
  <span fxFlex>Anleitung zu Listenfunktionen</span>
  <mat-icon class="cursor-mat-element" (click)="close()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <div class="ag-theme-material">
    <section class="ag-grid-help">
      <h2>Anleitung zu Listenfunktionen</h2>

      <ul>
        <li>
          <strong>
            Sortieren
            <span class="ag-icon ag-icon-desc" style="display: contents"></span>
            &amp; Filtern
            <span class="ag-icon ag-icon-filter" style="display: contents"></span>
          </strong>
          <br />
          Spalten können per Klick auf die Spaltenüberschrift auf- und absteigend sortiert werden. Unter der
          Überschrift befindet sich ein Textfeld zum Filtern der Spalteninhalte. Standardmäßig wird hier nach
          "Enthält" gefiltert. Weitere Filteroptionen sind mit Klick auf das Filter-Symbol rechts daneben
          verfügbar.
        </li>

        <li>
          <strong>
            Spalten anordnen &amp; anheften
            <span class="ag-icon ag-icon-pin" style="display: contents"></span>
          </strong>
          <br />
          Spalten können per Drag &amp; Drop verschoben werden. Um diese anzuheften, können die Spalten an den
          linken oder rechten Tabellenrand gezogen werden. Alternativ kann die Option "Anheften" im
          Spaltenmenü gewählt werden.
        </li>

        <li>
          <strong>Spaltenbreite anpassen</strong>
          <br />
          Um die Spaltenbreite anzupassen, kann der Rand der Spaltenüberschrift angeklickt und verschoben
          werden. Ein Doppelklick auf den Rand passt die Spaltenbreite automatisch an den längsten Inhalt an.
        </li>

        <li>
          <strong>
            Spaltenmenü
            <span class="ag-icon ag-icon-menu" style="display: contents"></span>
          </strong>
          <br />
          Jede Spalte verfügt über ein Menü mit schnellen Zugriffen auf Sortierung, Filter und weitere
          Optionen.
        </li>

        <li>
          <strong>
            Spalten ein- &amp; ausblenden
            <span class="ag-icon ag-icon-columns" style="display: contents"></span>
          </strong>
          <br />
          Über das Spaltenmenü im letzten Tab können einzelne Spalten ein- oder ausgeblendet werden.
        </li>

        <li>
          <strong>
            Aktualisieren
            <mat-icon>cached</mat-icon>
          </strong>
          <br />
          Mit dem "Aktualisieren"-Button wird die Tabelle neu geladen und Inhalte aktualisiert. Dabei wird die
          Tabelle zur ersten Seite zurückgesetzt.
        </li>

        <li>
          <strong>
            Filter zurücksetzen
            <mat-icon>search_off</mat-icon>
          </strong>
          <br />
          Mit dem "Filter zurücksetzen"-Button werden alle aktiven Filter entfernt und die Tabelle wird neu
          geladen.
        </li>

        <li>
          <strong>
            Spalten zurücksetzen
            <mat-icon>compare_arrows</mat-icon>
          </strong>
          <br />
          Mit dem "Spalten zurücksetzen"-Button werden alle Spalteneinstellungen zurückgesetzt. Dies betrifft
          die Anordnung, Größe, Sichtbarkeit und Sortierung der Spalten. Standardmäßig werden Tabellen nach
          absteigender ID sortiert.
        </li>

        <li>
          <strong>
            Excel Export
            <mat-icon>cloud_download</mat-icon>
          </strong>
          <br />
          Mit dem "Excel Export"-Button können die aktuellen Tabellendaten als Excel-Datei heruntergeladen
          werden. Für den Export wird die aktuelle Filterung und Sortierung berücksichtigt.
          <br />
          Hinweis: Im Export stehen alle Seiten der Tabelle zur Verfügung, nicht nur die aktuell angezeigte
          Seite. Dieser Export kann je nach Datenmenge einige Zeit in Anspruch nehmen.
        </li>
      </ul>
    </section>
  </div>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-close-button" (click)="close()">Schließen</button>
  </div>
</mat-dialog-content>
